export default function Logo({ size = 34 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      aria-label="MUBFAR box mark"
      data-testid="logo-mark"
    >
      <polygon points="16,3 29,9.5 16,16 3,9.5" fill="#10b981" />
      <polygon points="3,9.5 16,16 16,29 3,22.5" fill="#047857" />
      <polygon points="29,9.5 16,16 16,29 29,22.5" fill="#022c22" stroke="#10b981" strokeOpacity="0.5" strokeWidth="0.5" />
      <polygon points="16,3 18.6,4.3 5.6,10.8 3,9.5" fill="#d97706" />
      <polygon points="18.6,4.3 18.6,17.3 16,16 16,29 13.4,27.7 13.4,17.3 5.6,13.4 5.6,10.8" fill="#d97706" opacity="0.55" />
    </svg>
  );
}
